// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import collapseNav from './components/collapseNav'
import router from './router'
import 'reset-css'
import $ from 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'

import './assets/css/base.css'
import store from './store'
import axios from 'axios'
import fun from './assets/js/function.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Cookies from 'js-cookie';
import CustomDialog from './components/customDialog';
import privacyPolicy from './components/privacyPolicy';

// import fastClick from 'fastclick'
// fastClick.attach(document.body)
// import dd from 'dingtalk-jsapi';

Vue.use(CustomDialog);
Vue.use(ElementUI);
Vue.component('privacy-policy', privacyPolicy);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.fun = fun
Vue.prototype.bus = new Vue();
// Vue.prototype.$dd = dd


// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response && response.status === 200 && response.data && response.data.code === 401) {
      clearLoginStatus()
      return response;
    }
    if(null != Cookies.get("examineStatus")) {
        localStorage.setItem("examineStatus",Cookies.get("examineStatus"));
    } 
    if(null != Cookies.get("exmaineMessage")) {
        localStorage.setItem("exmaineMessage",Cookies.get("exmaineMessage"));
    }
    return response;
  },
  error => {
    if (error.response) {
          switch (error.response.status) {
            case 401:
                clearLoginStatus();
                break;
            case 501:
                // 返回 401 清除token信息并跳转到登录页面
                // router.replace({
                //     path: '/mem/callBack.htm',
                //     query: {wechatUrl: error.response.data}
                // })
                // alert(error.response.data);
                // this.$axios.post(error.response.data, {
                // }).then((res) => {
                //     alert(res);
                // }).catch((err) => {
                //     console.log(err)
                //   })
                window.location.href = error.response.data;
                break;
            }
      }
      return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  }
);
Vue.component('v-collapseNav', collapseNav)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  $,
  components: { App },
  template: '<App/>'
})


function clearLoginStatus () {
  localStorage.removeItem('isLogin');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('companyInfo');
  localStorage.removeItem('checkFlag');
  localStorage.removeItem('examineStatus');
  localStorage.removeItem('exmaineMessage');
  localStorage.removeItem('noticeInfos');
  localStorage.removeItem('userTag');
  localStorage.removeItem('coordinationSupplierAuthFlag');
  localStorage.removeItem('coordinationSystemAuthFlag');
  localStorage.removeItem('messageNumber');
  localStorage.removeItem('supplierManagerAuthFlag');
  localStorage.removeItem('isCompanyManager');


  // 返回 401 清除token信息并跳转到登录页面
  router.replace({
    path: 'login',
    query: {redirectURL: router.currentRoute.fullPath}
  })
}


// WEBPACK FOOTER //
// ./src/main.js